import React, { useEffect, useState } from "react";
import { Navbar, Nav, Row, Col ,Offcanvas } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import HomeSchema from "./HomeSchema";


const Header = ({ isMasterClass = false }) => {
  const location = useLocation();
  const isAboutPage = location.pathname === "/about";
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const [screenSize, setScreenSize] = useState(getDeviceType());
  const [desktopMenuOpen, setDesktopMenuOpen] = useState(false);


  useEffect(() => {
    if (expanded) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [expanded]);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scroll down → hide header
        setScrolled(true);
      } else if (currentScrollY < lastScrollY) {
        // Scroll up → show header
        setScrolled(false);
      }

      lastScrollY = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  /* ---- Masterclass Logout ---- */
  const authToken = localStorage.getItem("auth_token");
 
  /* ---- Masterclass Logout ---- */
  function getDeviceType() {
    const width = window.innerWidth;
    if (width <= 991) return "mobile";
    if (width >= 992 && width <= 1199) return "tablet";
    return "desktop";
  }
  useEffect(() => {
    const handleResize = () => setScreenSize(getDeviceType());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <HomeSchema />
      <Navbar
        expanded={expanded}
        expand="xl"
        className={`custom-navbar ${scrolled ? "hide-on-scroll" : ""} ${expanded ? "menu-open" : ""} ${isAboutPage ? "about-page" : ""}`}
        fixed="top"
        aria-label="Main Navigation"
      >
        {/* Logo */}


        
          {expanded ? (
            <Navbar.Brand href="/upcoming-events" className="menu-logo vue-btn-link">
            View upcoming events
                 </Navbar.Brand>   
          ) : (
            <Navbar.Brand href="/" className="menu-logo">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/header-logo.svg'}
              alt="Logo"
              className="head-logo"
            />
                 </Navbar.Brand>   


          )}  



        {/* Mobile Toggle Button */}
        <div className="navbar-toggle">
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(expanded ? false : "expanded")}
          >
            {expanded ? (
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/close-icon.png'} alt="Close Menu" className="menu-icons" />
            ) : (
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/menu-icon.png'} alt="Open Menu" className="menu-icon" />
            )}
          </Navbar.Toggle>
        </div>
        {/* Navigation Links */}
        <Navbar.Collapse id="basic-navbar-nav" className={expanded ? "show" : ""} aria-label="Main Navigation">
          {screenSize === "mobile" && (
            <>
              <Nav className="ms-auto align-items-center res-he">
                <Nav.Link href="/" title="Home">Home </Nav.Link>
                <Nav.Link href="/speed-dating" title="Speed Dating">Speed Dating </Nav.Link>
                <Nav.Link href="/singles-events" title="Singles Events">Singles Events</Nav.Link>
                <Nav.Link href="/singles-run-club" title="Singles Run Club">Singles Run Club</Nav.Link>
                {/* <Nav.Link href="/singles-weekend-getaway" title="Singles Run Club">Singles Weekend Getaway</Nav.Link> */}
                <Nav.Link href="/dating-masterclass" title="Dating Masterclasses">Dating Masterclasses</Nav.Link>
                <Nav.Link href="/call-me-card" title="Call Me Card">Call Me Cards</Nav.Link>
                <Nav.Link href="/about" title="About us">About Us</Nav.Link>
                <Nav.Link href="/brand-partnership" title="Brand Partnerships">Brand Partnerships</Nav.Link>
                <Nav.Link href="/contact" title="Contact">Contact</Nav.Link>
                <div className="d-flex button-icons-container justify-content-between">
                  <div className="d-flex social-icons">
                    {isMasterClass && (
                      <Nav.Link href={authToken ? "/profile" : "/login"} className="rek rekkss">
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/contact-frame.svg'} alt="Contact" style={{ width: '29px' }} />
                      </Nav.Link>
                    )}
                    <Nav.Link href="https://www.instagram.com/yourfriendmyfriend.ie" target="_blank" className="rek rekkk" title="Follow us on Instagram">
                      <img src={process.env.REACT_APP_BASE_URL + 'assests/images/instagram.svg'} alt="Instagram" />
                    </Nav.Link>
                    <Nav.Link href="https://www.tiktok.com/@yourfriendmyfriend.ie" target="_blank" className="rek rekkss" title="Follow us on TikTok">
                      <img src={process.env.REACT_APP_BASE_URL + 'assests/images/tiktok.svg'} alt="TikTok" />
                    </Nav.Link>
                  </div>
                  
                </div>
              </Nav>
            </>
          )}
          {screenSize === "tablet" && (
            <>
              <Nav className="ms-auto res-he">
                <Row>
                  <Col md={7} className="head-tab-left-main">
                    <div className="head-tab-left">
                      <h2>It's time to</h2>
                      <h2>stop swiping</h2>
                      <h2>& start dating.</h2>
                    </div>
                  </Col>
                  <Col md={5}>
                    <Link to="/upcoming-events" title="View Upcoming Events" className="vue-btn">View Upcoming Events </Link>
                    <Nav.Link href="/" title="Speed Dating">Home </Nav.Link>
                    <Nav.Link href="/speed-dating" title="Speed Dating">Speed Dating </Nav.Link>
                    <Nav.Link href="/singles-events" title="Singles Events">Singles Events</Nav.Link>
                    <Nav.Link href="/singles-run-club" title="Singles Run Club">Singles Run Club</Nav.Link>
                    {/* <Nav.Link href="/singles-weekend-getaway" title="Singles Run Club">Singles Weekend Getaway</Nav.Link> */}
                    <Nav.Link href="/dating-masterclass" title="Dating Masterclasses">Dating Masterclasses</Nav.Link>
                    <Nav.Link href="/call-me-card" title="Call Me Card">Call Me Cards</Nav.Link>
                    <Nav.Link href="/about" title="About us">About Us</Nav.Link>
                    <Nav.Link href="/brand-partnership" title="Brand Partnerships">Brand Partnerships</Nav.Link>
                    <Nav.Link href="/contact" title="Contact" className="cnt-link">Contact</Nav.Link>
                   
                    <div className="d-flex button-icons-container">
                      <div className="d-flex social-icons">
                        {isMasterClass && (
                          <Nav.Link href={authToken ? "/profile" : "/login"} className="rek rekkss">
                            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/contact-frame.svg'} alt="Contact" style={{ width: '29px' }} />
                          </Nav.Link>
                        )}
                        <Nav.Link href="https://www.instagram.com/yourfriendmyfriend.ie" target="_blank" className="rek rekkk" title="Follow us on Instagram">
                          <img src={process.env.REACT_APP_BASE_URL + 'assests/images/instagram.svg'} alt="Instagram" />
                        </Nav.Link>
                        <Nav.Link href="https://www.tiktok.com/@yourfriendmyfriend.ie" target="_blank" className="rek rekkss" title="Follow us on TikTok">
                          <img src={process.env.REACT_APP_BASE_URL + 'assests/images/tiktok.svg'} alt="TikTok" />
                        </Nav.Link>
                      </div>
                      
                    </div>
                  </Col>
                </Row>
              </Nav>
            </>
          )}
          {screenSize === "desktop" && (
            <>
              <Nav className="ms-auto align-items-center res-he">
                
                
                <div className="d-flex button-icons-container gap-2">
                  <div className="d-flex social-icons">
                    {isMasterClass && (
                      <Nav.Link href={authToken ? "/profile" : "/login"} className="rek rekkss">
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/contact-frame.svg'} alt="Contact" style={{ width: '29px' }} />
                      </Nav.Link>
                    )}
                    <Nav.Link href="https://www.instagram.com/yourfriendmyfriend.ie" target="_blank" className="rek rekkk" title="Follow us on Instagram">
                      <img src={process.env.REACT_APP_BASE_URL + 'assests/images/instagram.svg'} alt="Instagram" />
                    </Nav.Link>
                    <Nav.Link href="https://www.tiktok.com/@yourfriendmyfriend.ie" target="_blank" className="rek rekkss" title="Follow us on TikTok">
                      <img src={process.env.REACT_APP_BASE_URL + 'assests/images/tiktok.svg'} alt="TikTok" />
                    </Nav.Link>
                  </div>
                  <button type="submit" className="btn right-btn rek2 book-tickets" onClick={() => navigate("/upcoming-events")} style={{ fontSize: '11px' }}>
                    Book Tickets
                  </button>
                  <div
                    className="desktop-hamburger"
                    onClick={() => setDesktopMenuOpen(true)}
                  >
                    <img
                      src={process.env.REACT_APP_BASE_URL + 'assests/images/menu-icon.png'}
                      alt="Menu"
                      className="menu-icon"
                    />
                  </div>
                </div>
              </Nav>
            </>
          )}
        </Navbar.Collapse>
      </Navbar>
      <Offcanvas
        show={desktopMenuOpen}
        onHide={() => setDesktopMenuOpen(false)}
        placement="end"
        className="desktop-offcanvas"
      >
 
        <Offcanvas.Body>
          <div className="offcanvas-top d-flex justify-content-between align-items-center">
            <Navbar.Brand href="/upcoming-events" className="menu-logo new vue-btn-link ">
              View upcoming events
            </Navbar.Brand>
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/close-icon.png'} alt="Close Menu" className="menu-icons" onClick={() => setDesktopMenuOpen(false)} />
          </div>
          <Nav className="flex-column desktop-menu-links">
            <Nav.Link href="/speed-dating" title="Speed Dating">Speed Dating </Nav.Link>
            <Nav.Link href="/singles-events" title="Singles Events">Singles Events</Nav.Link>
            <Nav.Link href="/singles-run-club" title="Singles Run Club">Singles Run Club</Nav.Link>
            {/* <Nav.Link href="/singles-weekend-getaway" title="Singles Run Club">Singles Weekend Getaway</Nav.Link> */}
            <Nav.Link href="/dating-masterclass" title="Dating Masterclasses">Dating Masterclasses</Nav.Link>
            <Nav.Link href="/call-me-card" title="Call Me Card">Call Me Cards</Nav.Link>
            <Nav.Link href="/about" title="About us">About Us</Nav.Link>
            <Nav.Link href="/brand-partnership" title="Brand Partnerships">Brand Partnerships</Nav.Link>
            <Nav.Link href="/contact" title="Contact">Contact</Nav.Link>
            <div className="d-flex button-icons-container justify-content-between">
                  <div className="d-flex social-icons">
                    {isMasterClass && (
                      <Nav.Link href={authToken ? "/profile" : "/login"} className="rek rekkss new">
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/contact-frame.svg'} alt="Contact" style={{ width: '29px' }} />
                      </Nav.Link>
                    )}
                    <Nav.Link href="https://www.instagram.com/yourfriendmyfriend.ie" target="_blank" className="rek rekkk new" title="Follow us on Instagram">
                      <img src={process.env.REACT_APP_BASE_URL + 'assests/images/instagram.svg'} alt="Instagram" />
                    </Nav.Link>
                    <Nav.Link href="https://www.tiktok.com/@yourfriendmyfriend.ie" target="_blank" className="rek rekkss new" title="Follow us on TikTok">
                      <img src={process.env.REACT_APP_BASE_URL + 'assests/images/tiktok.svg'} alt="TikTok" />
                    </Nav.Link>
                  </div>
 
                </div>
          </Nav>
 
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
